var _defs, _path, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFencesEditModeOff = function SvgFencesEditModeOff(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "saida_geral",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878787;}.cls-2{fill:none;stroke:#878787;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.45,2.07H3.57c-1.13,0-2.04,.91-2.04,2.04V26.03c0,1.13,.91,2.04,2.04,2.04H25.49c1.13,0,2.04-.91,2.04-2.04V15.07"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.22,
    y: 2.5,
    width: 5.13,
    height: 22.23,
    rx: 0.21,
    ry: 0.21,
    transform: "translate(14.54 -7.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.82,2.2h1.61c.97,0,1.76,.79,1.76,1.76v1.18c0,.12-.1,.21-.21,.21h-4.7c-.12,0-.21-.1-.21-.21v-1.18c0-.97,.79-1.76,1.76-1.76Z",
    transform: "translate(10.47 -17.72) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.24,25.02l1.13-4.48c.02-.08,.13-.11,.19-.05l3.35,3.35c.06,.06,.03,.17-.05,.19l-4.48,1.13c-.08,.02-.16-.05-.14-.14Z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFencesEditModeOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fencesEditModeOff.c1e434a4.svg";
export { ForwardRef as ReactComponent };